import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1120px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          视频专区
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          漫画动画化资讯、PV预告、创作者访谈等精彩视频内容
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-white/90 rounded-full transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}